'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-toggle-channel-mode
 *
 * @description
 * #directive
 * Display section and button to switch to "À la carte" mode
 *
 * @template:'<div class="more-channel-container clearfix"><div class="h-wrapper"><h3>Ajout de blocs</h3></div><div class="v-action-buttons"><button type="button"><small>Basculer au mode à la carte</small></button></div></div>'
 */

angular.module('v-tv-package').component('vTvPackageToggleChannelMode', {
  template:'<div class="more-channel-container clearfix"><div class="h-wrapper"><h3>Ajout de blocs</h3></div><div class="v-action-buttons"><button type="button"><small>Basculer au mode à la carte</small></button></div></div>'
});